import React from 'react';
import CarnowCta from './CarnowCta';
import ContactDealerCta from './ContactDealerCta';
import CustomCta from './CustomCta';
import DarwinCta from './DarwinCta';
import GubagooCta from './GubagooCta';
import RoadsterCta from './Roadster/RoadsterCta';
import UpstartCta from './UpstartCta';
import CoxCta from './CoxCta';
import { VendorCTAType } from '../../redux/vendorCTAsReducer';

export interface VendorCtaSelectorProps {
  ctaDetails: VendorCTAType;
  variant: 'primary' | 'secondary';
  vin: string;
  vehicleId?: string;
  market?: string;
  mainDealer?: string;
  onContactModalOpen?: (arg: any) => void;
  vehicleType?: string;
}

// crop obj to only use the defined properties
export const getDefinedPropertiesOfCta = (cta: VendorCTAType) => {
  // eslint-disable-next-line
  const ctaWithDefindedPropeties = {} as any;
  // only adding non-null properties to cta object
  // eslint-disable-next-line
  for (const property in cta) {
    if (
      cta[property as keyof VendorCTAType] === null ||
      cta[property as keyof VendorCTAType] === undefined
    ) {
      // eslint-disable-next-line
      continue;
    }
    ctaWithDefindedPropeties[property] = cta[property as keyof VendorCTAType];
  }

  return ctaWithDefindedPropeties;
};
// eslint-disable-next-line
export const returnVendorButtonComponent = (
  ctaDetails: VendorCTAType,
  variant: 'primary' | 'secondary',
  vin: string,
  vehicleId?: string,
  market?: string,
  mainDealer?: string,
  vehicleType?: string,
  onContactModalOpen?: (arg: any) => void,
) => {
  let vendorComponent = <></>;

  const vendorData = getDefinedPropertiesOfCta(ctaDetails);

  // properties checked will always be unique
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('ctaVendorLink')) {
    vendorComponent = <CustomCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('flowOptionGubagoo')) {
    vendorComponent = <GubagooCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('pagePlacementTypeCarnow')) {
    vendorComponent = <CarnowCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('actionTypeRoadster')) {
    vendorComponent = <RoadsterCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('configTypeLocationUpstart')) {
    vendorComponent = <UpstartCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('configTypeLocationDarwin')) {
    vendorComponent = <DarwinCta ctaDetails={ctaDetails} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('ctaDealerId')) {
    vendorComponent = (
      <ContactDealerCta
        ctaDetails={ctaDetails}
        vehicleType={vehicleType}
        variant={variant}
        vin={vin}
        vehicleId={vehicleId}
        market={market}
        mainDealer={mainDealer}
      />
    );
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('coxCtaLabel')) {
    vendorComponent = <CoxCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  return vendorComponent;
};

const VendorCtaSelector = ({
  ctaDetails,
  variant,
  vin,
  onContactModalOpen,
  vehicleId,
  vehicleType,
  market,
  mainDealer,
}: VendorCtaSelectorProps) => {
  return returnVendorButtonComponent(
    ctaDetails,
    variant,
    vin,
    vehicleId,
    market,
    mainDealer,
    vehicleType,
    onContactModalOpen,
  );
};

export default VendorCtaSelector;
